// 登入類型常數，用於id-login頁面加載時判斷為企業登入或個人登入
export const ID_LOGIN_TYPE = {
  PERSONAL: '1',
  ENTERPRISE: '2',
};

// 頁籤常數，用於login-register頁面加載時指定預設頁籤
export const LOGIN_REGISTER_TABS = {
  LOGIN: 'login',
  REGISTER: 'register',
};

// BMI常數，用於問卷頁面顯示BMI計算input
export const BMI = 'BMI';

// 全日檢時數
export const FULL_DAY_CHECKUP_HOURS = '5~7';

// 高階影像dept name
export const IMAGE_DEPT_NAME = '影像醫學';

export const TRENDING_EXAM_DEPT_NAME = '熱門檢項';

// 聊天機器人顯示狀態
export const CHATBOT_SHOW_STATUS = {
  HIDE: 0, // 完全不顯示
  COLLAPSED: 1, // 預設關閉
  EXPANDED: 2, // 預設展開
};

// LINE QRCode 網址
export const LINE_URL = 'https://api.cresclab.com/system/a/?a=ojOR9cwUDqT9qIOZUJcYuLpylhRa9LWtFWbDtDmgctgIhAYv0VwsFkxI6BPdoUd8cSMlnAoGlvrWOpd6vVJ5C64nKuR1PXmzziatqYiIdkq5udZ0L7hmeHOFUfwKIKSk';
